module.exports = "/images/settings.svg?a58e41cf24613fa4aaa859e5eba64369";